import React, { forwardRef, ReactNode } from 'react';
import { Container, TopToScrollButtonContainer } from './styles';
import FloatingButton from '@/components/FloatingButton';
import Image from 'next/image';

type WorkContentLayoutProps = {
  children: ReactNode;
  showTopButton: boolean;
  onScrollToTop: () => void;
};

/** 스크롤 가능한 작업 영역 최상위 레이아웃 (맨 위로 버튼 포함) */
const WorkContentLayout = forwardRef<HTMLDivElement, WorkContentLayoutProps>(
  ({ children, showTopButton, onScrollToTop }, ref) => {
    return (
      <Container ref={ref}>
        {children}
        <TopToScrollButtonContainer>
          <FloatingButton show={showTopButton} handleClick={onScrollToTop}>
            <Image
              src={'/icons/arrow-up.svg'}
              alt={'scroll on Top'}
              width={14}
              height={14}
            />
          </FloatingButton>
        </TopToScrollButtonContainer>
      </Container>
    );
  },
);

WorkContentLayout.displayName = 'WorkContentLayout';

export default WorkContentLayout;
